module.exports = __webpack_public_path__ + "img/acos_cover.beee295.png";